import React from 'react';
import { Volume2, VolumeX } from 'lucide-react';

interface AudioSelectorProps {
  hasAudio: boolean;
  onAudioChange: (hasAudio: boolean) => void;
}

const AudioSelector: React.FC<AudioSelectorProps> = ({ hasAudio, onAudioChange }) => {
  return (
    <div className="flex gap-3">
      <button
        type="button"
        onClick={() => onAudioChange(true)}
        className={`
          flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-lg border transition-all
          ${hasAudio 
            ? 'bg-purple-50 border-purple-200 text-purple-700 dark:bg-purple-900/20 dark:border-purple-700 dark:text-purple-300' 
            : 'bg-background border-border text-muted-foreground hover:border-purple-200'
          }
        `}
      >
        <Volume2 className="h-4 w-4" />
        <span className="text-sm font-medium">With Audio</span>
      </button>
      
      <button
        type="button"
        onClick={() => onAudioChange(false)}
        className={`
          flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-lg border transition-all
          ${!hasAudio 
            ? 'bg-purple-50 border-purple-200 text-purple-700 dark:bg-purple-900/20 dark:border-purple-700 dark:text-purple-300' 
            : 'bg-background border-border text-muted-foreground hover:border-purple-200'
          }
        `}
      >
        <VolumeX className="h-4 w-4" />
        <span className="text-sm font-medium">Without Audio</span>
      </button>
    </div>
  );
};

export default AudioSelector; 